(function () {
  var focusableSelector = 'a[href], area[href], button, input, select, textarea, iframe, object, embed, audio[controls], video[controls], [contenteditable], [tabindex]';
  var storedTabindex = 'data-cp-a11y-tabindex';
  function text(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function setName(el, name) {
    if (!el || !name) return;
    if (el.getAttribute('aria-label') !== name) {
      el.setAttribute('aria-label', name);
    }
  }

  function queryAroundRoot(root, selector) {
    var scope = root || document;
    var matches = [];
    function add(el) {
      if (el && matches.indexOf(el) === -1) matches.push(el);
    }
    if (scope.nodeType === 1 && scope.closest) add(scope.closest(selector));
    scope.querySelectorAll(selector).forEach(add);
    return matches;
  }

  function replaceElementTag(el, tagName) {
    var next;
    if (!el || !el.parentNode || el.tagName.toLowerCase() === tagName) return el;
    next = (el.ownerDocument || document).createElement(tagName);
    Array.prototype.slice.call(el.attributes).forEach(function (attr) {
      next.setAttribute(attr.name, attr.value);
    });
    while (el.firstChild) next.appendChild(el.firstChild);
    el.parentNode.replaceChild(next, el);
    return next;
  }

  function ensureFallbackH1() {
    if (document.querySelector('h1')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var h1 = document.createElement('h1');
    h1.className = 'visually-hidden cp-a11y-fallback-h1';
    h1.textContent = document.title.replace(/\s+[–|-]\s+.*$/, '').trim() || 'CREP Protect';
    main.insertBefore(h1, main.firstChild);
  }

  function ensureCookieConsentContrast() {
    if (document.getElementById('cp-a11y-cookie-consent-contrast')) return;
    var style = document.createElement('style');
    style.id = 'cp-a11y-cookie-consent-contrast';
    style.textContent = 'csm-cookie-consent #isense-cc-cookie-bar-text,csm-cookie-consent .isense-cc-link,csm-cookie-consent .cc-link,#isense-cc-cookie-bar-text,.isense-cc-link{color:#111!important;}csm-cookie-consent .isense-cc-link,csm-cookie-consent .cc-link,.isense-cc-link{text-decoration-color:currentColor!important;}.page .action,.action[data-i18n="refresh-page"]{color:#111!important;text-decoration-color:currentColor!important;}';
    document.head.appendChild(style);
  }

  function ensurePageLandmark(root) {
    (root || document).querySelectorAll('.page').forEach(function (page) {
      if (page.closest('main, [role="main"], [role="region"], [role="complementary"], [role="contentinfo"], [role="banner"], [role="navigation"]')) return;
      page.setAttribute('role', 'main');
      if (!page.id) page.id = 'MainContent';
      setName(page, 'Main content');
    });
  }

  function normalizeHeaderControls(root) {
    (root || document).querySelectorAll('[data-link-wishlist]').forEach(function (link) {
      var linkLabel = link.getAttribute('aria-label') || 'Wishlist';
      var fallback = link.querySelector('.cp-a11y-wishlist-label');
      if (text(link)) {
        link.removeAttribute('aria-label');
      } else {
        setName(link, linkLabel);
        if (!fallback) {
          fallback = document.createElement('span');
          fallback.className = 'visually-hidden cp-a11y-wishlist-label';
          link.appendChild(fallback);
        }
        fallback.textContent = linkLabel;
      }
      link.querySelectorAll('[data-count-wishlist]').forEach(function (count) {
        if (count.getAttribute('aria-hidden') !== 'true') {
          count.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function normalizeReadMore(root) {
    (root || document).querySelectorAll('.t4s-article-readmore').forEach(function (link) {
      var visible = text(link);
      if (!visible) return;
      var titleLink = link.closest('.t4s-article, article');
      titleLink = titleLink && titleLink.querySelector('.t4s-article-title a');
      var label = visible;
      if (titleLink && text(titleLink)) label += ': ' + text(titleLink);
      setName(link, label);
    });
  }

  function normalizeLandmarks(root) {
    var landmarkNames = Object.create(null);
    (root || document).querySelectorAll('[role="region"], [data-flickityt4s-js], .flickityt4s, .t4s-slide-eff-slide').forEach(function (region) {
      if (!region.getAttribute('role')) region.setAttribute('role', 'region');
      if (region.matches('[data-flickityt4s-js], .flickityt4s, .t4s-slide-eff-slide')) {
        if (region.getAttribute('aria-roledescription') !== 'carousel') {
          region.setAttribute('aria-roledescription', 'carousel');
        }
      }
      var label = region.getAttribute('aria-label') || '';
      if (!label) {
        var section = region.closest('[id^="shopify-section-"], section, .t4s-section-inner');
        var heading = section && section.querySelector('h1,h2,h3,[data-heading]');
        label = text(heading) || 'Content region';
      }
      if (landmarkNames[label]) {
        landmarkNames[label] += 1;
        label = label + ' ' + landmarkNames[label];
      } else {
        landmarkNames[label] = 1;
      }
      setName(region, label);
    });
  }

  function normalizeNavigationLandmarks(root) {
    var navNames = Object.create(null);
    (root || document).querySelectorAll('nav, [role="navigation"]').forEach(function (nav) {
      var label = nav.getAttribute('aria-label') || '';
      if (!label) {
        if (nav.classList.contains('t4s-navigation')) {
          label = 'Main navigation';
        } else if (nav.classList.contains('t4s-breadcrumbs') || nav.classList.contains('t4s-pr-breadcrumb')) {
          label = 'Breadcrumb';
        } else if (nav.classList.contains('t4s-pagination') || nav.classList.contains('navigation')) {
          label = 'Pagination';
        } else {
          label = 'Navigation';
        }
      }
      if (navNames[label]) {
        navNames[label] += 1;
        label = label + ' ' + navNames[label];
      } else {
        navNames[label] = 1;
      }
      setName(nav, label);
    });
  }

  function hideFocusableDescendants(container) {
    container.querySelectorAll(focusableSelector).forEach(function (el) {
      if (!el.hasAttribute(storedTabindex)) {
        el.setAttribute(storedTabindex, el.getAttribute('tabindex') || '');
      }
      if (el.getAttribute('tabindex') !== '-1') {
        el.setAttribute('tabindex', '-1');
      }
      if (el.tagName === 'A' || el.tagName === 'BUTTON' || el.getAttribute('role') === 'button') {
        if (el.getAttribute('aria-hidden') !== 'true') {
          el.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  function restoreFocusableDescendants(container) {
    container.querySelectorAll('[' + storedTabindex + ']').forEach(function (el) {
      var previous = el.getAttribute(storedTabindex);
      if (previous === '') el.removeAttribute('tabindex');
      else el.setAttribute('tabindex', previous);
      el.removeAttribute(storedTabindex);
      if (el.getAttribute('aria-hidden') === 'true' && !el.closest('[aria-hidden="true"]')) {
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function normalizeHiddenFocus(root) {
    (root || document).querySelectorAll('[aria-hidden="true"]').forEach(hideFocusableDescendants);
    (root || document).querySelectorAll('[aria-hidden="false"], .is-selected, .is-active').forEach(restoreFocusableDescendants);
  }

  function normalizeInstafeed(root) {
    (root || document).querySelectorAll('.inline-product.instafeed-new-layout-item-container, .inline-product[data-instafeed-open-id][data-feed-id]').forEach(function (card, cardIndex) {
      if (card.tagName !== 'A' && card.getAttribute('role') === 'button') {
        card.removeAttribute('role');
      }
      if (card.hasAttribute('tabindex') && card.querySelector('a,button')) {
        card.removeAttribute('tabindex');
      }
      var title = text(card.querySelector('.instafeed-product-title, .instafeed-product-name, .instafeed-product-info'));
      card.querySelectorAll('.instafeed-product-info a[aria-label="Open product"]').forEach(function (link) {
        setName(link, title ? 'Open product: ' + title : 'Open product');
      });
      card.querySelectorAll('#instafeed-product-container').forEach(function (container, containerIndex) {
        var feedId = card.getAttribute('data-feed-id') || 'feed';
        var openId = card.getAttribute('data-instafeed-open-id') || String(cardIndex);
        container.id = 'instafeed-product-container-' + feedId.replace(/[^a-zA-Z0-9_-]/g, '-') + '-' + openId.replace(/[^a-zA-Z0-9_-]/g, '-') + '-' + containerIndex;
      });
    });
  }

  function normalizeSpiceGrid(root) {
    (root || document).querySelectorAll('.cp-spice-grid[role="list"]').forEach(function (grid) {
      grid.querySelectorAll(':scope > .cp-spice-card').forEach(function (card) {
        if (card.tagName === 'LI') {
          card.removeAttribute('role');
        } else if (card.tagName !== 'ARTICLE' && card.getAttribute('role') !== 'listitem') {
          card.setAttribute('role', 'listitem');
        }
      });
    });
  }

  function ensureIntercomLabelStyles(doc) {
    doc = doc || document;
    if (doc.getElementById('cp-a11y-intercom-label-style') || !doc.head) return;
    var style = doc.createElement('style');
    style.id = 'cp-a11y-intercom-label-style';
    style.textContent = '.cp-a11y-intercom-label{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}';
    doc.head.appendChild(style);
  }

  function getIntercomLabel(button) {
    var currentLabel = (button.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
    var visibleText = getIntercomVisibleText(button);
    var lowerCurrent = currentLabel.toLowerCase();
    var lowerVisible = visibleText.toLowerCase();
    if (visibleText && lowerCurrent && lowerCurrent.indexOf(lowerVisible) === 0) {
      return currentLabel;
    }
    if (visibleText && currentLabel) {
      return visibleText + ' - ' + currentLabel;
    }
    if (visibleText) {
      return visibleText;
    }
    if (/^close\b/i.test(currentLabel)) {
      return currentLabel || 'Close Intercom Messenger';
    }
    return currentLabel || 'Open Intercom Messenger';
  }

  function getIntercomVisibleText(button) {
    var clone;
    if (!button) return '';
    clone = button.cloneNode(true);
    clone.querySelectorAll('.cp-a11y-intercom-label, [aria-hidden="true"], svg').forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    return text(clone).replace(/\s+/g, ' ').trim();
  }

  function normalizeIntercomControls(root) {
    var scope = root || document;
    var doc = scope.nodeType === 9 ? scope : scope.ownerDocument || document;
    ensureIntercomLabelStyles(doc);
    queryAroundRoot(scope, '.intercom-launcher[role="button"], .intercom-c5j4w9[role="button"], [role="button"][aria-label="Open Intercom Messenger"], [role="button"][aria-label="Close Intercom Messenger"], [role="button"][aria-label="Open Live Chat - Speak to Customer Service"], [role="button"][aria-label="Close Live Chat - Speak to Customer Service"]').forEach(function (button) {
      var labelText = getIntercomLabel(button);
      setName(button, labelText);
      var label = button.querySelector('.cp-a11y-intercom-label');
      if (!label) {
        label = doc.createElement('span');
        label.className = 'cp-a11y-intercom-label';
        button.appendChild(label);
      }
      if (label.textContent !== labelText) label.textContent = labelText;
    });
    queryAroundRoot(scope, '[role="region"][aria-label^="Intercom messenger"], [role="region"][aria-label^="Intercom live chat"]').forEach(function (region, index) {
      setName(region, index ? 'Intercom live chat region ' + (index + 1) : 'Intercom live chat region');
    });
  }

  function normalizeIntercomFrame(frame) {
    var frameDoc;
    if (!frame.hasAttribute('data-cp-a11y-intercom-load')) {
      frame.setAttribute('data-cp-a11y-intercom-load', 'true');
      frame.addEventListener('load', function () { normalizeIntercomFrame(frame); });
    }
    try {
      frameDoc = frame.contentDocument || frame.contentWindow.document;
    } catch (error) {
      return;
    }
    if (!frameDoc || !frameDoc.documentElement) return;
    if (!frame.getAttribute('title')) frame.setAttribute('title', 'Intercom live chat launcher frame');
    if (!frame.getAttribute('aria-label')) frame.setAttribute('aria-label', 'Intercom live chat launcher frame');
    normalizeIntercomControls(frameDoc);
    if (!frameDoc.cpA11yIntercomObserver) {
      frameDoc.cpA11yIntercomObserver = new MutationObserver(function () {
        normalizeIntercomControls(frameDoc);
      });
      frameDoc.cpA11yIntercomObserver.observe(frameDoc.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label', 'class', 'role']
      });
    }
  }

  function normalizeIntercom(root) {
    normalizeIntercomControls(root || document);
    queryAroundRoot(root, 'iframe.intercom-launcher-frame, iframe.intercom-launcher-discovery-frame').forEach(normalizeIntercomFrame);
  }

  function normalizeHelpCenter(root) {
    (root || document).querySelectorAll('.help-center-hero button.flex[type="submit"], .help-article__search button.flex[type="submit"], .help-article-controls button.flex[type="submit"], button.click-pointer-none[type="submit"]').forEach(function (button) {
      setName(button, 'Search');
      if (!text(button)) {
        var label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = 'Search';
        button.appendChild(label);
      }
    });
    (root || document).querySelectorAll('.help-center-categories__mobile-link').forEach(function (link) {
      var item = link.closest('.help-center-categories__item');
      var label = text(item && item.querySelector('.help-center-categories-item__preview, .help-center-categories-item__info'));
      setName(link, label ? 'Open ' + label : 'Open help category');
    });
  }

  function normalizeProductControls(root) {
    (root || document).querySelectorAll('[data-decrease-qty]').forEach(function (button) {
      setName(button, 'Decrease quantity');
    });
    (root || document).querySelectorAll('[data-increase-qty]').forEach(function (button) {
      setName(button, 'Increase quantity');
    });
    (root || document).querySelectorAll('input[name="quantity"], [data-quantity-value]').forEach(function (input) {
      setName(input, 'Quantity');
    });
    (root || document).querySelectorAll('.t4s-carousel__nav-scroller').forEach(function (scroller) {
      if (!scroller.hasAttribute('tabindex')) scroller.setAttribute('tabindex', '0');
      if (!scroller.getAttribute('role')) scroller.setAttribute('role', 'region');
      setName(scroller, 'Product media thumbnails');
    });
    (root || document).querySelectorAll('.t4s-sticky-atc, [data-sticky-add-to-cart]').forEach(function (sticky) {
      if (!sticky.getAttribute('role')) sticky.setAttribute('role', 'region');
      setName(sticky, 'Sticky add to cart');
    });
    (root || document).querySelectorAll('.product-add-to-cart').forEach(function (button) {
      var visible = text(button);
      if (visible) setName(button, visible);
    });
  }

  function normalizePdpRecommendations(root) {
    (root || document).querySelectorAll('.cp-pdp-reco__item[role="listitem"]').forEach(function (item) {
      var parent = item.parentElement;
      if (parent && parent.getAttribute('role') !== 'list') {
        parent.setAttribute('role', 'list');
      }
    });
  }

  function normalizeEmptyHeadings(root) {
    (root || document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
      if (text(heading)) return;
      heading.setAttribute('aria-hidden', 'true');
      heading.setAttribute('role', 'presentation');
    });
  }

  function normalizeNonStructuralHeadings(root) {
    queryAroundRoot(root, '.tab-content-wrapper.t4s-container > h5').forEach(function (heading) {
      var paragraph = replaceElementTag(heading, 'p');
      paragraph.setAttribute('data-cp-a11y-heading-fix', 'paragraph');
      paragraph.removeAttribute('role');
      paragraph.removeAttribute('aria-level');
    });
  }

  function headingLevel(heading) {
    var tagLevel = /^H([1-6])$/.exec(heading.tagName || '');
    var ariaLevel = parseInt(heading.getAttribute('aria-level'), 10);
    if (heading.getAttribute('role') === 'heading' && ariaLevel >= 1 && ariaLevel <= 6) return ariaLevel;
    return tagLevel ? parseInt(tagLevel[1], 10) : 0;
  }

  function isHeadingHidden(heading) {
    return !text(heading) || heading.getAttribute('aria-hidden') === 'true' || heading.getAttribute('role') === 'presentation' || !!heading.closest('[hidden], [aria-hidden="true"], template');
  }

  function setHeadingLevel(heading, level) {
    var next;
    if (/^H[1-6]$/.test(heading.tagName || '')) {
      next = replaceElementTag(heading, 'h' + level);
      next.setAttribute('data-cp-a11y-heading-level', String(level));
      return next;
    }
    heading.setAttribute('role', 'heading');
    heading.setAttribute('aria-level', String(level));
    heading.setAttribute('data-cp-a11y-heading-level', String(level));
    return heading;
  }

  function normalizeHeadingOrder(root) {
    var doc = root && root.nodeType === 9 ? root : root && root.nodeType === 1 ? root.ownerDocument : document;
    var previousLevel = 0;
    doc.querySelectorAll('h1,h2,h3,h4,h5,h6,[role="heading"][aria-level]').forEach(function (heading) {
      var level;
      var targetLevel;
      if (isHeadingHidden(heading)) return;
      level = headingLevel(heading);
      if (!level) return;
      targetLevel = previousLevel && level > previousLevel + 1 ? previousLevel + 1 : level;
      if (!previousLevel && level > 1) targetLevel = 1;
      if (targetLevel !== level) heading = setHeadingLevel(heading, targetLevel);
      previousLevel = headingLevel(heading);
    });
  }

  function normalizePayPalBrand(root) {
    (root || document).querySelectorAll('.cp-pay-in-3__brand[aria-label]').forEach(function (brand) {
      brand.removeAttribute('aria-label');
    });
  }

  function replaceTokenList(value, oldId, newId) {
    if (!value) return value;
    return value.split(/\s+/).map(function (token) {
      return token === oldId ? newId : token;
    }).join(' ');
  }

  function updateIdReferences(scope, oldId, newId) {
    if (!scope || !oldId || !newId) return;
    scope.querySelectorAll('*').forEach(function (node) {
      ['fill', 'stroke', 'clip-path', 'filter', 'mask', 'style'].forEach(function (attr) {
        var value = node.getAttribute(attr);
        if (value && value.indexOf('url(#' + oldId + ')') !== -1) {
          node.setAttribute(attr, value.split('url(#' + oldId + ')').join('url(#' + newId + ')'));
        }
      });
      ['href', 'xlink:href'].forEach(function (attr) {
        var value = node.getAttribute(attr);
        if (value === '#' + oldId) node.setAttribute(attr, '#' + newId);
      });
      ['aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'for'].forEach(function (attr) {
        var value = node.getAttribute(attr);
        var nextValue = replaceTokenList(value, oldId, newId);
        if (nextValue && nextValue !== value) node.setAttribute(attr, nextValue);
      });
    });
  }

  function normalizeDocumentIds(root) {
    var doc = root && root.nodeType === 9 ? root : root && root.nodeType === 1 ? root.ownerDocument : document;
    var seen = Object.create(null);
    doc.querySelectorAll('[id]').forEach(function (node, index) {
      var id = node.id;
      var nextId;
      var refScope;
      if (!id) return;
      if (!seen[id]) {
        seen[id] = 1;
        return;
      }
      seen[id] += 1;
      nextId = id + '-cp-a11y-' + seen[id] + '-' + index;
      refScope = node.closest('svg') || doc;
      updateIdReferences(refScope, id, nextId);
      node.id = nextId;
    });
  }

  function dedupeSvgIds(root) {
    (root || document).querySelectorAll('svg').forEach(function (svg, svgIndex) {
      var seen = Object.create(null);
      svg.querySelectorAll('[id]').forEach(function (node, nodeIndex) {
        var id = node.id;
        if (!seen[id]) {
          seen[id] = 1;
          return;
        }
        var nextId = id + '-cp-a11y-' + svgIndex + '-' + nodeIndex;
        updateIdReferences(svg, id, nextId);
        node.id = nextId;
      });
    });
  }

  function normalizeAccessibleFrames(root) {
    queryAroundRoot(root, 'iframe#widget-frame, #freshworks-frame-wrapper iframe').forEach(function (frame) {
      var frameDoc;
      if (!frame.hasAttribute('data-cp-a11y-frame-load')) {
        frame.setAttribute('data-cp-a11y-frame-load', 'true');
        frame.addEventListener('load', function () { normalizeAccessibleFrames(frame); });
      }
      try {
        frameDoc = frame.contentDocument || frame.contentWindow.document;
      } catch (error) {
        return;
      }
      if (!frameDoc || !frameDoc.documentElement) return;
      normalizeEmptyHeadings(frameDoc);
      normalizeNonStructuralHeadings(frameDoc);
      normalizeHeadingOrder(frameDoc);
      normalizeDocumentIds(frameDoc);
      dedupeSvgIds(frameDoc);
      if (!frame.hasAttribute('data-cp-a11y-frame-observed')) {
        frame.setAttribute('data-cp-a11y-frame-observed', 'true');
        try {
          new MutationObserver(function () {
            schedule(frameDoc);
          }).observe(frameDoc.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-hidden', 'aria-level', 'id', 'fill', 'stroke', 'href', 'xlink:href', 'role', 'style']
          });
        } catch (error) {}
      }
    });
  }

  function normalize(root) {
    ensureFallbackH1();
    ensureCookieConsentContrast();
    ensurePageLandmark(root);
    normalizeHeaderControls(root);
    normalizeReadMore(root);
    normalizeLandmarks(root);
    normalizeNavigationLandmarks(root);
    normalizeHiddenFocus(root);
    normalizeInstafeed(root);
    normalizeSpiceGrid(root);
    normalizeIntercom(root);
    normalizeHelpCenter(root);
    normalizeProductControls(root);
    normalizePdpRecommendations(root);
    normalizeEmptyHeadings(root);
    normalizeNonStructuralHeadings(root);
    normalizeHeadingOrder(root);
    normalizePayPalBrand(root);
    normalizeDocumentIds(root);
    dedupeSvgIds(root);
    normalizeAccessibleFrames(root);
  }

  function schedule(root) {
    window.requestAnimationFrame(function () { normalize(root || document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document); });
  } else {
    schedule(document);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) schedule(node);
      });
      if (mutation.type === 'attributes') schedule(mutation.target);
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'aria-label', 'class', 'id', 'role']
  });
})();
